import { Link } from 'react-router-dom'
import footerData from 'src/data/footer-data.json'

function FooterLink({onClick, footer_id}){
    const data = footerData.filter(x => x.id === footer_id)[0]
    return(
        <div className='flex flex-col gap-[8px] group/link'>
            <div id="footer-link-header" className='text-[16px] lg:text-[20px] group-hover:text-lightBlack group-hover/link:!text-white duration-200'>{data.label}</div>
            <ul className='flex flex-col gap-[4px] font-light text-[12px] lg:text-[16px]'>
                {data.link.map(x => {
                    return(
                        <li onClick={onClick} className='group-hover:text-lightBlack hover:!text-white duration-200 transition-colors group/item'>
                            <Link to={x.url}>{x.label}</Link>
                        </li>
                    )
                })}
            </ul>
        </div>
    )
}

export default FooterLink